import { Bounce, Flip, Slide, Zoom } from 'react-toastify';
export let PositionNotification = /*#__PURE__*/function (PositionNotification) {
  PositionNotification["TOP_RIGHT"] = "top-right";
  PositionNotification["TOP_CENTER"] = "top-center";
  PositionNotification["TOP_LEFT"] = "top-left";
  PositionNotification["BOTTOM_RIGHT"] = "bottom-right";
  PositionNotification["BOTTOM_CENTER"] = "bottom-center";
  PositionNotification["BOTTOM_LEFT"] = "bottom-left";
  return PositionNotification;
}({});
export let ThemeNotification = /*#__PURE__*/function (ThemeNotification) {
  ThemeNotification["LIGHT"] = "light";
  ThemeNotification["DARK"] = "dark";
  ThemeNotification["COLORED"] = "colored";
  ThemeNotification["CUSTOM_PROJECT"] = "custom-project";
  return ThemeNotification;
}({});
export let TypeNotification = /*#__PURE__*/function (TypeNotification) {
  TypeNotification["DEFAULT"] = "default";
  TypeNotification["INFO"] = "info";
  TypeNotification["SUCCESS"] = "success";
  TypeNotification["WARNING"] = "warning";
  TypeNotification["ERROR"] = "error";
  return TypeNotification;
}({});
export let TransitionNotification = /*#__PURE__*/function (TransitionNotification) {
  TransitionNotification["SLIDE"] = "slide";
  TransitionNotification["BOUNCE"] = "bounce";
  TransitionNotification["ZOOM"] = "zoom";
  TransitionNotification["FLIP"] = "flip";
  return TransitionNotification;
}({});
export const getTransitionAnimation = transition => {
  if (transition === TransitionNotification.BOUNCE) {
    return Bounce;
  } else if (transition === TransitionNotification.FLIP) {
    return Flip;
  } else if (transition === TransitionNotification.SLIDE) {
    return Slide;
  } else if (transition === TransitionNotification.ZOOM) {
    return Zoom;
  }
  return undefined;
};